<template>
  <div>
    <v-progress-linear indeterminate color="purple" class="mb-2" v-if="cargando" />
    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-table-reporte-ejecucion-presupuestaria"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="datosDesembolsosPorSedes.tabla"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :pinnedBottomRowData="pinnedBottomRowData"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true"
      @first-data-rendered="onFirstDataRendered"
      @grid-ready="onGridReady">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { AgGridVue } from 'ag-grid-vue';
import { formatearValorAMoneda } from '../utils';

export default {
  name: 'ListadoReporteDesembolsosPorSedes',
  components: {
    AgGridVue,
  },
  props: {
    datosDesembolsosPorSedes: {
      type: Object,
      required: true,
      validator: (value) => {
        return (
          value &&
          typeof value === 'object' &&
          value.hasOwnProperty('sedes') &&
          value.hasOwnProperty('clasificadores') &&
          value.hasOwnProperty('tabla') &&
          value.hasOwnProperty('totales')
        );
      },
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    pinnedBottomRowData() {
      return [this.datosDesembolsosPorSedes.totales];
    },
    columnDefs() {
      const columnasBase = [
        {
          headerName: 'CÓDIGO',
          field: 'codigo',
          filter: true,
          checkboxSelection: true,
          minWidth: 150,
        },
        {
          headerName: 'DETALLE',
          field: 'clasificador',
          filter: true,
          minWidth: 350,
        },
        {
          headerName: 'ACEPTA REGISTRO',
          field: 'acepta_registro',
          cellRenderer: (params) => {
            if (params.node.rowPinned) {
              return undefined;
            }

            const aceptaRegistro = params.data.acepta_registro;
            const texto = aceptaRegistro ? 'SI' : 'NO';
            const colorTexto = aceptaRegistro ? 'green' : 'red';

            return /*html*/ `<span style="color: ${colorTexto}">${texto}</span>`;
          },
          valueGetter: (params) => {
            const aceptaRegistro = params.data.acepta_registro ? 'SI' : 'NO';
            return aceptaRegistro;
          },
          filter: true,
          minWidth: 130,
          maxWidth: 130,
        },
      ];

      const columnasSedes = this.datosDesembolsosPorSedes.sedes
        ? this.datosDesembolsosPorSedes.sedes.map((sede) => ({
            headerName: sede.toUpperCase(),
            field: sede,
            filter: true,
            minWidth: 150,
            type: 'numericColumn',
            valueFormatter: (params) => {
              return formatearValorAMoneda(params.value);
            },
          }))
        : [];

      const columnaTotal = {
        headerName: 'TOTAL',
        field: 'total',
        filter: true,
        minWidth: 150,
        type: 'numericColumn',
        valueFormatter: (params) => {
          return params.value !== undefined && params.value !== null ? formatearValorAMoneda(params.value) : '';
        },
      };

      return [...columnasBase, ...columnasSedes, columnaTotal];
    },
  },
  data() {
    return {
      gridOptions: {
        suppressPropertyNamesCheck: true,
        suppressMovableColumns: true,
        localeText: {
          noRowsToShow: 'No hay filas para mostrar',
          contains: 'Contiene',
          notContains: 'No Contiene',
          equals: 'Es Igual',
          notEqual: 'No es Igual',
          startsWith: 'Comienza con',
          endsWith: 'Termina con',
          filterOoo: 'Filtrar...',
        },
        enableCellTextSelection: true,
      },
      defaultColDef: {
        sortable: false,
        filter: true,
        floatingFilter: true,
        //editable: false,
        resizable: true,
        suppressMenu: true,
      },
    };
  },
  methods: {
    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
  },
};
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
@import './../css/styles.css';

.ag-grid-table-reporte-ejecucion-presupuestaria {
  height: calc(var(--vh, 1vh) * 100 - 19.5rem);
}

.ag-header-group-cell-label {
  justify-content: center !important;
}
</style>